import React from 'react';
import { Link } from 'react-router-dom';
import './InErrorPageStyles.css';

export default function InErrorPage({ children, errorCode = "404", errorMessage = "Page not found" }) {
    return (
        <div className="error-container-page">
            <div className="error-background">
                <div className="floating-shapes">
                    <div className="shape shape-1"></div>
                    <div className="shape shape-2"></div>
                    <div className="shape shape-3"></div>
                    <div className="shape shape-4"></div>
                </div>
            </div>

            <div className="error-logo-container">
                <Link to="/" className="logo-link">
                    <img 
                        src="/patricians.png" 
                        alt="Patricians Logo" 
                        className="logo-image"
                    />
                </Link>
            </div>

            <div className="error-card">
                <div className="error-icon">
                    <div className="error-number">{errorCode}</div>
                    <div className="error-icon-decoration">
                        <span className="icon-dot"></span>
                        <span className="icon-dot"></span>
                        <span className="icon-dot"></span>
                    </div>
                </div>

                <h1 className="error-title">Oops !</h1>
                <h2 className="error-subtitle">{errorMessage}</h2>
                
                <p className="error-description">
                    {errorCode === "404" 
                        ? "The page you are looking for seems to have vanished into the depths of cyberspace."
                        : "An unexpected error occurred. Our team has been notified."
                    }
                </p>

                <div className="error-actions">
                    <Link to="/" className="btn btn-primary">
                        <i className="bi bi-house-door"></i>
                        <span>Back to home</span>
                    </Link>
                    
                    <Link to="/shop" className="btn btn-secondary">
                        <i className="bi bi-shop"></i>
                        <span>Discover the shop</span>
                    </Link>
                </div>

                {children && (
                    <div className="error-additional-content">
                        {children}
                    </div>
                )}
            </div>

            <div className="error-footer">
                <p>If the problem persists, contact our technical support.</p>
            </div>
        </div>
    );
}
